import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CompanyOverview() {
    return (
        <section className="py-12 px-2.5 md:px-4 bg-gray-50/30 mt-4">
            <div className="w-full md:max-w-7xl mx-auto">
                <div className="text-center mb-4 md:mb-8">
                    <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-blue-800">
                        PVR CABS Transport Services
                    </h1>
                    <p className="text-sm md:text-base lg:text-lg font-medium mt-1 w-full md:max-w-4xl mx-auto text-gray-700 leading-relaxed">
                        PVR CABS offers premium, reliable transport in Telangana, tailored for professionals and corporate travel needs, with top-brand vehicles and expert service ensuring safety, punctuality, and comfort.
                    </p>

                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
                    {/* Corporate Travel */}
                    <div className="group flex flex-col md:flex-row gap-6 p-5 md:p-8 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border-2 border-gray-100">
                        <div className="w-full md:w-44 h-48 md:h-full bg-blue-50 rounded-xl flex-shrink-0 items-center ju`st`ify-center text-blue-600 group-hover:bg-blue-100 transition-colors overflow-hidden">
                            <img
                                src="/CompanyOverview1.png"
                                alt="Corporate Travel Solutions"
                                className="object-cover w-full h-full rounded-xl"
                            />
                        </div>
                        <div className="flex-1">
                            <h2 className="text-base md:text-lg lg:text-xl font-semibold text-blue-900 mb-1">Corporate Travel Solutions</h2>
                            <p className="text-sm md:text-sm lg:text-base text-gray-600 mb-3 leading-relaxed">
                                We provide reliable transport with clean vehicles and trained drivers for smooth, stress-free commutes to offices, meetings, and business events.
                            </p>
                            <Link to="/corporate-car" className="text-xs md:text-sm inline-flex items-center text-gray-600 font-medium hover:text-blue-800 transition-colors">
                                Known more <ArrowRight size={18} className="ml-2" />
                            </Link>
                        </div>
                    </div>

                    {/* Trusted Service */}
                    <div className="group flex flex-col md:flex-row gap-6 p-5 md:p-8 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border-2 border-gray-100">
                        <div className="w-full md:w-44 h-48 md:h-full bg-blue-50 rounded-xl flex-shrink-0 items-center justify-center text-blue-600 group-hover:bg-blue-100 transition-colors overflow-hidden">
                            <img
                                src="/CompanyOverview2.png"
                                alt="Reliable Trusted Service"
                                className="object-cover w-full h-full rounded-xl"
                            />
                        </div>
                        <div className="flex-1">
                            <h2 className="text-base md:text-lg lg:text-xl font-semibold text-blue-900 mb-1">Reliable Trusted Service</h2>
                            <p className="text-sm md:text-sm lg:text-base text-gray-600 mb-3 leading-relaxed">
                                From airport pickups to event rides, we deliver timely, secure, and comfortable travel across Telangana with 24/7 availability and professional chauffeurs.
                            </p>
                            <Link to="/airport-transfer" className="text-xs md:text-sm inline-flex items-center text-gray-600 font-medium hover:text-blue-800 transition-colors">
                                Known more <ArrowRight size={18} className="ml-2" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}